import { createReducer, on } from '@ngrx/store';
import configActions from './config.actions';
import { ApiState } from '../../model/api-state.model';
import { DefaultConfig } from '../../model/default-config.model';
import AppError from '../../model/app-error';
import { GlobtroterUserResult, GlobtroterMenuResult, GlobtroterConfigResult } from '../../model/globtroter-config';

export { configActions as actions };

export * from './config.selectors';

export interface State {
  state: ApiState;
  data: DefaultConfig | null;
  error: AppError | null;
  menuConfigState: ApiState;
  menuConfigData: GlobtroterMenuResult | null;
  menuConfigError: AppError | null;
  globtroterUserState: ApiState;
  globtroterUserData: GlobtroterUserResult | null;
  globtroterUserError: AppError | null;
  globtroterConfigState: ApiState;
  globtroterConfigData: GlobtroterConfigResult | null;
  globtroterConfigError: AppError | null;
}

export const initialState: State = {
  state: ApiState.idle,
  data: null,
  error: null,
  menuConfigState: ApiState.idle,
  menuConfigData: null,
  menuConfigError: null,
  globtroterUserState: ApiState.idle,
  globtroterUserData: null,
  globtroterUserError: null,
  globtroterConfigState: ApiState.idle,
  globtroterConfigData: null,
  globtroterConfigError: null,
};

export const reducer = createReducer(
  initialState,
  on(configActions.fetchStart, (state) => ({ ...state, state: ApiState.pending, data: null, error: null })),
  on(configActions.fetchSuccess, (state, { data }) => ({ ...state, state: ApiState.success, data, error: null })),
  on(configActions.fetchError, (state, { error }) => ({ ...state, state: ApiState.error, data: null, error })),
  on(configActions.fetchMenuConfigStart, (state) => ({
    ...state,
    menuConfigState: ApiState.pending,
    menuConfigData: null,
    menuConfigError: null,
  })),
  on(configActions.fetchMenuConfigSuccess, (state, { data }) => ({
    ...state,
    menuConfigState: ApiState.success,
    menuConfigData: data,
    menuConfigError: null,
  })),
  on(configActions.fetchMenuConfigError, (state, { error }) => ({
    ...state,
    menuConfigState: ApiState.error,
    menuConfigData: null,
    menuConfigError: error,
  })),
  on(configActions.fetchGlobtroterUserStart, (state) => ({
    ...state,
    globtroterUserState: ApiState.pending,
    globtroterUserData: null,
    globtroterUserError: null,
  })),
  on(configActions.fetchGlobtroterUserSuccess, (state, { data }) => ({
    ...state,
    globtroterUserState: ApiState.success,
    globtroterUserData: data,
    globtroterUserError: null,
  })),
  on(configActions.fetchGlobtroterUserError, (state, { error }) => ({
    ...state,
    globtroterUserState: ApiState.error,
    globtroterUserData: null,
    globtroterUserError: error,
  })),
  on(configActions.fetchGlobtroterConfigStart, (state) => ({
    ...state,
    globtroterConfigState: ApiState.pending,
    globtroterConfigData: null,
    globtroterUserError: null,
  })),
  on(configActions.fetchGlobtroterConfigSuccess, (state, { data }) => ({
    ...state,
    globtroterConfigState: ApiState.success,
    globtroterConfigData: data,
    globtroterConfigError: null,
  })),
  on(configActions.fetchGlobtroterConfigError, (state, { error }) => ({
    ...state,
    globtroterConfigState: ApiState.error,
    globtroterConfigData: null,
    globtroterConfigError: error,
  })),
);
